.root {
  overflow: hidden;
  // Code reads left to right in every language, line numbers included.
  direction: ltr;
  border: 1px solid var(--color-code-border);
  border-radius: var(--radius-lg);
  background: var(--color-code-background) !important;
  color: var(--color-code-foreground);
  color-scheme: dark;
  scrollbar-color: var(--color-code-muted) var(--color-code-background);
}

.code {
  background: var(--color-code-background) !important;

  :global(.monaco-editor),
  :global(.monaco-editor-background),
  :global(.monaco-editor .margin) {
    --vscode-editorGutter-background: var(--color-code-background);
    --vscode-editor-background: var(--color-code-background);
    --vscode-focusBorder: transparent;
    --vscode-editorStickyScroll-background: var(--color-code-background-raised);

    background-color: var(--color-code-background) !important;
  }

  :global(.monaco-editor) {
    :global(.sticky-widget) {
      box-shadow: 0 8px 18px rgb(0 0 0 / 0.28);
    }
  }
}

/* Static rendering (read-only, or before editing starts): editor look without Monaco. */

.static {
  height: 100%;
  direction: ltr;
  margin: 0;
  border: 0;
  background: var(--color-code-background) !important;
  overflow: auto;
  padding: 14px 14px 14px 0;
  font-family: var(--font-mono);
  color: var(--color-code-foreground);
  white-space: pre;
  counter-reset: line;
  tab-size: 2;

  > code {
    font: inherit;
    color: inherit;
  }

  &[data-softwrap="true"] {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
}

.line {
  display: block;
  padding-left: 3.75em;
  text-indent: -3.75em;
  counter-increment: line;

  &::before {
    content: counter(line);
    display: inline-block;
    width: 2.75em;
    margin-right: 1em;
    color: #8794a8;
    text-align: right;
    text-indent: 0;
    user-select: none;
  }
}
